import { useNavigate, useParams } from 'react-router-dom';

import useQuery from '@/hooks/useQuery';

import errors from '@/constants/errors';

import { useMemo } from 'react';

const usePaymentLikError = () => {
  const query = useQuery();
  const { id } = useParams();
  const errorCode = query.get('error_code');

  const navigate = useNavigate();

  const handleClick = () => navigate(`/${id}`);

  const errorConfig = useMemo(() => {
    const currentState = errorCode ?? 'default';

    const error = errors[currentState as keyof typeof errors];

    return error ?? errors.default;
  }, [errorCode]);

  return {
    paymentId: id,
    errorConfig,
    handleClick,
  };
};

export default usePaymentLikError;
